import React from "react";
import PropTypes from "prop-types";

const LocationPinOutlinedIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const resolvedStroke = stroke || color || "currentColor";

  return (
    <svg
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M16.6673 8.33366C16.6673 12.4945 12.0515 16.8278 10.5015 18.1662C10.2048 18.3892 9.79645 18.3892 9.49982 18.1662C7.94982 16.8278 3.33398 12.4945 3.33398 8.33366C3.33398 4.65423 6.32122 1.66699 10.0007 1.66699C13.6801 1.66699 16.6673 4.65423 16.6673 8.33366"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 8.33301C7.5 9.7128 8.62021 10.833 10 10.833C11.3798 10.833 12.5 9.7128 12.5 8.33301C12.5 6.95322 11.3798 5.83301 10 5.83301C8.62021 5.83301 7.5 6.95322 7.5 8.33301V8.33301"
        stroke={resolvedStroke}
        strokeWidth={strokeWidth || 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

LocationPinOutlinedIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

LocationPinOutlinedIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default LocationPinOutlinedIcon;
